//import $ from 'jquery';
import 'jquery-validation';

class ModuleForm {
  init() {
    this.initForm();
  }

  initForm = () => {
    this.resetForm();
    const that = this;

    jQuery("#contact_form").validate({

      rules: {
        name: 'required',
        email: {
          required: true,
          email: true
        },
        message:'required',
        privacy:'required'
      },
      messages: {
        name: 'Bitte geben Sie Ihren Namen ein.',
        email: 'Bitte geben Sie Ihre korrekte E-Mail ein.',
        message: 'Bitte geben Sie Ihre Nachricht ein.',
        privacy: 'Bitte akzeptieren Sie die Datenschutzbestimmungen.'
      },
      submitHandler: function (form) {
        // Führe die Google reCAPTCHA v3-Abfrage durch
        grecaptcha.execute('6LeuII8qAAAAALjoecXzrZ3qZIHbk2moqa9b53IU', { action: 'submit' }).then(function (token) {
          // Füge das reCAPTCHA-Token zum Formular hinzu
          const recaptchaInput = document.createElement('input');
          recaptchaInput.type = 'hidden';
          recaptchaInput.name = 'g-recaptcha-response';
          recaptchaInput.value = token;
          form.appendChild(recaptchaInput);

          // Sende das Formular per AJAX
          const $form = $(form);
          $.ajax({
            url: $form.attr("action"),
            type: $form.attr("method"),
            data: $form.serialize(), // Alle Formulardaten inkl. Token
            dataType: "json",
            success: function (response) {
              const messageContainer = document.getElementById('form-message'); // ID des Containers
              if (response.success) {
                // Erfolgsmeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-success">${response.message}</div>`;
                $form.trigger("reset"); // Formular zurücksetzen
                that.resetForm();
              } else {
                // Fehlermeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-danger">${response.message}</div>`;
              }

            },
            error: function () {
              // Generelle Fehlermeldung bei AJAX-Fehlern
              const messageContainer = document.getElementById('form-message'); // ID des Containers
              messageContainer.innerHTML = `<div class="alert alert-danger">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</div>`;
              //$form.trigger("reset");
              that.resetForm();
            },
          });
        });

        return false; // Verhindert das standardmäßige Absenden des Formulars
      },

    });

    jQuery("#manager_form").validate({

      rules: {
        firstname: 'required',
        lastname: 'required',
        street: 'required',
        street_number: 'required',
        plz: 'required',
        city: 'required',
        email: {
          required: true,
          email: true
        },
        phone:'required',
        privacy:'required'
      },
      messages: {
        firstname: 'Bitte geben Sie Ihren Vornamen ein.',
        lastname: 'Bitte geben Sie Ihren Nachnamen ein.',
        street: 'Bitte geben Sie Ihre Strasse ein.',
        street_number: 'Bitte geben Sie Ihre Hausnummer ein.',
        plz: 'Bitte geben Sie Ihre Postleitzahl ein.',
        city: 'Bitte geben Sie Ihren Ort ein.',
        email: 'Bitte geben Sie Ihre korrekte E-Mail ein.',
        phone: 'Bitte geben Sie Ihre Telefon oder Mobilnummer ein.',
        knowledge: 'Bitte geben Sie Ihre Kenntnisse, Qualifikationen oder persönliches Profil ein.',
        job: 'Bitte geben Sie Festanstellung oder Freelance ein.',
        message: 'Bitte geben Sie Ihre Nachricht ein.',
        privacy: 'Bitte akzeptieren Sie die Datenschutzbestimmungen.'
      },
      // Überarbeite den Submit-Handler mit der Integration der Google reCAPTCHA v3
      submitHandler: function (form) {
        // Führe die Google reCAPTCHA-Überprüfung durch
        grecaptcha.execute('6LeuII8qAAAAALjoecXzrZ3qZIHbk2moqa9b53IU', { action: 'submit' }).then(function (token) {
          // Füge das Token als verstecktes Feld hinzu
          const recaptchaInput = document.createElement('input');
          recaptchaInput.type = 'hidden';
          recaptchaInput.name = 'g-recaptcha-response';
          recaptchaInput.value = token;
          form.appendChild(recaptchaInput);

          // Sende das Formular mit AJAX
          $.ajax({
            url: form.action, // URL aus dem Formular
            type: form.method, // POST-Methode
            data: $(form).serialize(), // Alle Daten serialisiert mit reCAPTCHA-Token
            dataType: "json", // JSON-Antwort erwartet
            success: function (response) {
              const messageContainer = document.getElementById('form-message'); // ID des Containers
              if (response.success) {
                // Erfolgsmeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-success">${response.message}</div>`;
                $form.trigger("reset"); // Formular zurücksetzen
                that.resetForm();
              } else {
                // Fehlermeldung anzeigen
                messageContainer.innerHTML = `<div class="alert alert-danger">${response.message}</div>`;
              }

            },
            error: function () {
              // Generelle Fehlermeldung bei AJAX-Fehlern
              const messageContainer = document.getElementById('form-message'); // ID des Containers
              messageContainer.innerHTML = `<div class="alert alert-danger">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.</div>`;
              that.resetForm();
            },
          });
        });

        return false; // Standardformular-Absenden verhindern
      },



    });
  }

  resetForm = () => {
    jQuery('#name').val('');
    jQuery('#email').val('');
    jQuery('#message').val('');
    jQuery('#privacy').prop('checked', false);


    jQuery('#fistname').val('');
    jQuery('#lastname').val('');
    jQuery('#street').val('');
    jQuery('#street_number').val('');
    jQuery('#plz').val('');
    jQuery('#city').val('');
    jQuery('#email').val('');
    jQuery('#phone').val('');
    jQuery('#knowledge').val('');
    jQuery('#job').val('');
    jQuery('#message').val('');
    jQuery('#privacy').prop('checked', false);
    jQuery('#einwilligung').prop('checked', false);
  }
}

export default ModuleForm;
